import Cookies from 'js-cookie'
// custom event
export const useCategoryPageViewedTracking = (props) => {
  const { currency, locale, category } = props
  
  const fbc = Cookies.get('_fbc')
  const fbp = Cookies.get('_fbp')
  
  if (typeof window !== 'undefined' && window.analytics) {
    window.analytics.track('Category Page Viewed', {
      currency,
      locale,
      category,
      value: 0,
      branch: window?.phill?.BRANCH,
      action_source: "website",
      fbc: fbc || null,
      fbp: fbp || null
    })
  }
}
